import * as React from 'react'
import { PoweredByToastModal } from '../../../../client/components/PoweredByToastModal/PoweredByToastModal'
import { SmsConfirmation } from '@local/do-secundo-sms-confirmation-component'
import { useHistory, useLocation } from 'react-router-dom'
import {
  CodeConfirmationForm,
  CodeConfirmationFormProps
} from '@local/do-secundo-code-confirmation'
import {
  useIsAccountLinkingEnabled,
  hasPasswordlessAccount
} from '@local/do-secundo-passwordless-authentication'
import { ModeLink } from '../../../../client/components/ModeRouter/utils'
import { ModalHeaderWithBackButton } from '../ModalHeaderWithBackButton'
export interface SmsVerificationModalProps extends CodeConfirmationFormProps {
  onClose?: () => void
  handleResend: () => void
  phone: string
  secondaryText?: React.ReactNode
}

export const SmsVerificationModal = ({
  onClose = () => {},
  handleSubmit,
  numFields,
  handleResend,
  phone
}: SmsVerificationModalProps) => {
  const history = useHistory()
  const { state } = useLocation<{ from: string }>()
  const text =
    state?.from === 'login' ? (
      <>
        You're one step closer to logging in. Enter the code we sent to&nbsp;
        <b>{phone}</b> to finish logging in.
      </>
    ) : (
      <>
        You're one step closer to creating your account. Enter the code we sent
        to&nbsp;<b>{phone}</b> to finish creating your account.
      </>
    )

  const ACCOUNT_LINKING_ENABLED = useIsAccountLinkingEnabled()

  const dataIdSuffix = state?.from === 'login' ? 'login' : 'create'

  const form = (
    <CodeConfirmationForm
      testId={`code-confirmation-form-${dataIdSuffix}`}
      numFields={numFields}
      handleSubmit={handleSubmit}
      idPrefix={'modal'}
    />
  )

  return (
    <div className={'text-center'} data-testid={'sms-verification-modal'}>
      <PoweredByToastModal
        onClose={onClose}
        header={
          <ModalHeaderWithBackButton
            onClick={() => history.goBack()}
            headerText='One step away'
            testId={`sms-verification-modal-${dataIdSuffix}-back-button`}
          />
        }
      >
        <p className='mb-4 type-default' data-testid='sms-modal-description'>
          {text}
        </p>
        <SmsConfirmation
          form={form}
          handleResend={handleResend}
          testId={`sms-confirmation-modal-${dataIdSuffix}`}
        />
        {state?.from === 'login' && !hasPasswordlessAccount() && (
          <div className={'pt-4 text-center'}>
            <p>Having trouble logging in? </p>
            <span
              onClick={() => {
                if (ACCOUNT_LINKING_ENABLED) {
                  history.push('?mode=connectLogin', {
                    accountLinkingEnabled: ACCOUNT_LINKING_ENABLED,
                    phone
                  })
                } else {
                  // this mirrors what we're doing in LoginPasswordlessModal
                  // it exists for the scenario that when we're not doing account linking
                  // we need to add the auth key to localStorage to switch to a legacy experience.
                  window.localStorage.setItem('auth', JSON.stringify({}))
                }
              }}
            >
              <ModeLink
                data-testid='sms-modal-passwordless-legacy-login'
                style='primary'
                mode='login'
              >
                Log in with email and password
              </ModeLink>
            </span>
            <p>or</p>
            <ModeLink
              data-testid='sms-modal-create-account-link-secondary'
              style='primary'
              mode='create'
            >
              Create an account
            </ModeLink>
          </div>
        )}
        {state?.from === 'login' && hasPasswordlessAccount() && (
          <div className={'pt-4 text-center'}>
            Having trouble logging in?{' '}
            <ModeLink
              data-testid='sms-modal-create-account-link'
              style='primary'
              mode='create'
            >
              Create account
            </ModeLink>
          </div>
        )}
      </PoweredByToastModal>
    </div>
  )
}
